export const SESSION_END_MESSAGES = new Set([
	'Сессия истекла',
	'Доступ заблокирован',
	'Профиль не найден',
	'Роль изменена. Переподключитесь.',
	'Пин-код изменён. Войдите снова.',
]);

/** Back `GET /sender-panel/me` 403 when the sender module is disabled (not a session problem). */
export const SENDER_DISABLED_MESSAGE = 'Telegram sender отключён';

export function isSessionEndMessage(message: string | null | undefined): message is string {
	return Boolean(message && SESSION_END_MESSAGES.has(message));
}

export function isSenderDisabledMessage(message: string | null | undefined): message is string {
	return message === SENDER_DISABLED_MESSAGE;
}
